import _ from 'lodash';

export const spinSpeed = {
  SLOW:   'slow',
  MEDIUM: 'medium',
  FAST:   'fast'
};
spinSpeed.ALL = _.values(spinSpeed);

export default spinSpeed;
